
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'
import { useDicomStore } from '@/store/dicom'
import { useReadingResultStore } from '@/store/readingResult'

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const router = useRouter();
    const popupStore = usePopupStore();
    const dicomStore = useDicomStore();
    const readingResultStore = useReadingResultStore();
    const duplicationFileList = computed(() => dicomStore.getDuplicationFileList);

    const closePopup = () => {
      popupStore.togglePopup('duplication', false);
      dicomStore.initDuplicationFileList();
    }

    const handleConfirmClick = async (): Promise<void> => {
      closePopup();
    }

    onMounted(() => {
    });

    return {
      closePopup,
      handleConfirmClick,
      duplicationFileList
    };
  },
});
